import { createParagraphsFromText } from '~/editor/nodes';
import { insertNodes, removeNodes, findNode } from '@udecode/plate';
import { GenerateContentElement } from '~/editor/plugins/generate-content/nodes/GenerateContentElement';
import { getGeneratedText } from '../api/getGeneratedText';

export async function generateText({
  editor,
  organizationId,
  action,
  annotation,
}): Promise<void | boolean> {
  const { prompt, isHighlighted } = editor.prompt?.() || {};

  if (!prompt) {
    throw new Error('Prompt cannot be empty');
  }

  let fullPrompt = prompt;
  if (annotation) {
    fullPrompt = fullPrompt.concat(`. ${annotation}`);
  }

  await getGeneratedText({
    organizationId,
    prompt: fullPrompt,
    isHighlighted,
    action,
  })
    .then((response) => {
      const suggestion = findNode(editor, {
        at: [],
        match: (n) => GenerateContentElement.is(n),
      });

      if (suggestion) {
        removeNodes(editor, {
          at: suggestion[1],
        });
      }

      const paragraphs = createParagraphsFromText(response);
      const position = suggestion ? suggestion[1] : editor.children.length;

      insertNodes(
        editor,
        { type: 'generate-content-element', children: paragraphs },
        { at: [position] }
      );

      editor.hasGeneratedContent = true;

      return true;
    })
    .catch((errorMessage) => {
      throw new Error(errorMessage.message);
    });
}
